import { render, staticRenderFns } from "./SLevelEducationComponent.vue?vue&type=template&id=8e522332&scoped=true"
import script from "./SLevelEducationComponent.vue?vue&type=script&lang=js"
export * from "./SLevelEducationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e522332",
  null
  
)

export default component.exports